<template>
  <div class="row h-100">
    <div class="col-12 h-100 d-flex flex-column">
      <div class="d-flex justify-content-end">
        <span v-if="isSaving">
          <b-button variant="primary" size="lg" disabled>
            <b-spinner small />
            {{ 'saving' | i18n }}
          </b-button>
        </span>
        <span v-else>
          <b-button variant="primary" size="lg" @click="create">
            {{ 'save' | i18n }}
          </b-button>
        </span>
      </div>
      <div class="poppins planned-content no-top-padding overflow-hidden d-flex flex-column h-100">
        <BlockHeader name="Details" class="mt-0" />
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-6">
            <Select v-model="selectedYear" :on-change="init" :options="yearOptions" form-group-id="Year" placeholder="year" />
          </div>
          <div class="col-lg-6 col-sm-6 col-6 mt-4 pt-1">
            <SearchInput :search-change="searchChange" class="search-input" />
          </div>
        </div>
        <TableLogBook v-if="loaded" :set-backend-data="setBackendData" :year-data="yearData" />
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import TableLogBook from './table-log-book';

import moment from 'moment';
import api from '../../../api';
import Notification from '../../common/notification';

import SearchInput from '../../common/search-input';
import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';

const currentYear = Number(moment().format('YYYY'));

let inputInterval = null;

export default {
  title: 'Log Book',
  components: { SearchInput, Loader, BlockHeader, Select, TableLogBook },
  data() {
    return {
      loaded: false,
      isSaving: false,
      selectedYear: currentYear,
      yearOptions: [],
      yearData: {
        year: '',
        days: [],
      },
      backendData: {},
      searchQuery: '',
    };
  },
  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    setBackendData(v, name, date) {
      this.backendData[date][name] = v;
    },
    searchChange(e) {
      const v = e.target.value;
      this.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.init();
      }, 500);
    },
    async init() {
      localStorage.setItem('selectedYear', this.selectedYear);
      this.loaded = false;
      const responce = await api.logBook.get({ year: this.selectedYear, searchQuery: this.searchQuery });

      this.backendData = {};
      this.yearData = {
        year: '',
        days: [],
      };
      if (responce && responce.days && responce.days.length) {
        this.yearData = responce;
        responce.days.forEach((d) => {
          this.backendData[d.date] = d;
        });
      } else {
        const startDate = moment(`${this.selectedYear}-01-01`);
        const a = moment([this.selectedYear, 11, 31]);
        const b = moment([this.selectedYear, 0, 1]);
        const currentAmountOfDays = a.diff(b, 'days');
        
        Array.from({ length: currentAmountOfDays + 1 }, () => {
          this.yearData.year = this.selectedYear;

          const d = {
            date: startDate.format('YYYY-MM-DD'),
            comment: '',
          };
          this.backendData[startDate.format('YYYY-MM-DD')] = d;

          this.yearData.days.push(d);

          startDate.add(1, 'day');
        });
      }

      this.loaded = true;
    },
    async create() {
      try {
        this.isSaving = true;
        await api.logBook.create({
          year: this.selectedYear,
          days: this.yearData.days.map((d) => this.backendData[d.date]),
        });
        Notification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
        this.init();
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}

.no-top-padding {
  padding-top: 0;
}

.search-input {
  width: fit-content;
  margin-left: auto;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
